<script setup>
import ga4 from '#common/utils/ga4'

import ErrorList from '#common/components/ErrorList.vue'
defineProps({
  autoFocus: {
    type: Boolean,
    required: false,
    default: true,
  },
})

const emit = defineEmits(['closed', 'register-success'])
const { $auth, $axios } = useNuxtApp()
const signupmodalwrapper = ref(null)
const qesEmail = ref('')
const zipcode = ref('')
const qesErrors = ref({})
const loading = ref(false)
const qesShowLabel = (inputId) => {
  $(`#${inputId}`).parent().siblings('label').addClass('show')
}
const qesHideLabel = (inputId) => {
  $(`#${inputId}`).parent().siblings('label').removeClass('show')
}
const close = () => {
  signupmodalwrapper.value.setAttribute('aria-hidden', 'true')
  emit('closed')
}
async function registerQes(data) {
  qesErrors.value = {}
  loading.value = true
  try {
    await $auth.registerQes(data)
    emit('register-success')
    ga4.track('register')
    const result = await $axios.get('/api/customer/user/')
    $auth.setUser(result.data)
  } catch (errors) {
    qesErrors.value = errors.response.data
  }
  loading.value = false
}
</script>

<template>
  <div
    ref="signupmodalwrapper"
    class="modal__body qes-modal-body modal-container home-email-modal"
    role="dialog"
    aria-label="Expertly curated wines and the stories behind them. Delivered straight to your inbox."
  >
    <div style="display: none" role="alert">Sign up for email modal</div>
    <div class="row shaded">
      <div class="columns medium-4 photo medium-push-8">
        <button
          class="modal-close-x"
          style="width: 30px"
          role="button"
          aria-label="Close sign up"
          @keydown.esc="close()"
          @click="close()"
        >
          &#x2715;
        </button>
      </div>
      <div class="columns medium-8 text medium-pull-4">
        <header>
          <h2 id="home-email-title">
            Expertly curated wines and the stories behind them.
          </h2>
        </header>
        <p id="home-email-description">Delivered straight to your inbox.</p>
        <FormKit
          type="form"
          :actions="false"
          class="signup-form row"
          @submit="registerQes"
        >
          <div class="signup-email columns small-12 medium-8 large-5">
            <FormKit
              id="signup-email"
              :formulate-value="qesEmail"
              :autofocus="autoFocus"
              label="Email Address"
              type="email"
              name="qesEmail"
              validation="required|email"
              maxlength="255"
              placeholder="Your email address"
              error-behavior="submit"
              @focus="qesShowLabel('signup-email')"
              @keydown.esc="close()"
              @blur="
                () => {
                  if (!qesEmail) {
                    qesHideLabel('signup-email')
                  }
                }
              "
            />
          </div>
          <div class="signup-zip columns small-12 medium-4 large-3">
            <FormKit
              id="signup-zip"
              :formulate-value="zipcode"
              type="text"
              name="zipcode"
              label="Zip code"
              placeholder="Zip code"
              error-behavior="submit"
              validation="required|matches:/^\d{5}(?:-\d{4})?$/"
              :validation-messages="{
                matches: 'Error: You must input a valid US Zip Code',
              }"
              @focus="qesShowLabel('signup-zip')"
              @keydown.esc="close()"
              @blur="
                () => {
                  if (!zipcode) {
                    qesHideLabel('signup-zip')
                  }
                }
              "
            />
          </div>
          <div class="signup-submit columns small-12 medium-12 large-4">
            <FormKit
              :disabled="loading"
              outer-class="no-pad"
              class="black"
              type="submit"
              label="Join Now"
              @keydown.esc="close()"
            />
          </div>
          <ErrorList :errors="Object.values(qesErrors).flat()" />
        </FormKit>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.modal-close-x {
  cursor: pointer;
  float: right;
  font-size: 1.6rem;
  color: #000;
  background: none transparent;
  min-width: 1px;
  max-width: 100%;
  width: 30px;
  text-align: center;
  padding: 0 4px;
  display: block;
  @media (max-width: 640px) {
    margin-right: -16px;
    margin-top: -22px;
    padding: 0;
  }
  &:hover,
  &:active,
  &:focus {
    color: #000;
    background: none transparent;
  }
}
.qes-modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.no-pad {
  padding: 0 !important;
}
</style>
